import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "stopwatch, track" }, [
      _createElementVNode("g", { id: "vector" }, [
        _createElementVNode("path", {
          d: "M7.3125 1.125C7.00184 1.125 6.75 1.37684 6.75 1.6875C6.75 1.99816 7.00184 2.25 7.3125 2.25H10.6875C10.9982 2.25 11.25 1.99816 11.25 1.6875C11.25 1.37684 10.9982 1.125 10.6875 1.125H7.3125Z",
          fill: "currentColor"
        }),
        _createElementVNode("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M15.75 9.75C15.75 13.4779 12.7279 16.5 9 16.5C5.27208 16.5 2.25 13.4779 2.25 9.75C2.25 6.02208 5.27208 3 9 3C12.7279 3 15.75 6.02208 15.75 9.75ZM6.35225 7.89775C6.13258 7.67808 6.13258 7.32192 6.35225 7.10225C6.57192 6.88258 6.92808 6.88258 7.14775 7.10225L9.39775 9.35225C9.61742 9.57192 9.61742 9.92808 9.39775 10.1477C9.17808 10.3674 8.82192 10.3674 8.60225 10.1477L6.35225 7.89775Z",
          fill: "currentColor"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }